import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';

import InventoryConversionTabs from './InventoryConversionTabs';
import {
  getInventoryConversionBinLabel,
  getInventoryConversionCreatedByLabel,
  getInventoryConversionDocDate,
  getInventoryConversionItemLabel,
  getInventoryConversionTypeConfig,
  getInventoryConversionUnitCode,
  getInventoryConversionWarehouseLabel,
} from './inventoryConversionHelper';

const DetailField = ({ label, value }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" component="div">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={600}>
      {value || '-'}
    </Typography>
  </Box>
);

const InventoryConversionPage = ({ selectedValues, users }) => {
  if (!selectedValues?.id) {
    return (
      <Paper variant="outlined" sx={{ p: 3, m: 2, borderStyle: 'dashed', bgcolor: 'grey.50' }}>
        <Typography variant="h6">Összeállítás / Bontás napló</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Válassz ki egy sort a jobb oldali listából, és itt megjelennek a művelet részletei.
        </Typography>
      </Paper>
    );
  }

  const typeConfig = getInventoryConversionTypeConfig(selectedValues?.conversionType);
  const itemLabel = getInventoryConversionItemLabel(selectedValues);
  const quantityValue = [selectedValues?.qty, getInventoryConversionUnitCode(selectedValues)].filter(Boolean).join(' ');
  const warehouseLabel = getInventoryConversionWarehouseLabel(selectedValues);
  const binLabel = getInventoryConversionBinLabel(selectedValues);
  const createdByLabel = getInventoryConversionCreatedByLabel(selectedValues, users);
  const docDate = getInventoryConversionDocDate(selectedValues);

  return (
    <Box className="h-full overflow-auto custom-scrollbar" sx={{ p: 2 }}>
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          borderWidth: 2,
          borderColor: typeConfig.borderColor,
          bgcolor: typeConfig.backgroundColor,
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2} useFlexGap flexWrap="wrap">
          <Box>
            <Typography variant="h6" component="h1" fontWeight={700}>
              Összeállítás / Bontás napló
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {itemLabel || 'Nincs kiválasztott cikk'}
            </Typography>
          </Box>

          <Chip
            label={`${typeConfig.marker} ${typeConfig.label}`}
            sx={{
              bgcolor: typeConfig.backgroundColor,
              color: typeConfig.color,
              border: `1px solid ${typeConfig.borderColor}`,
              fontWeight: 700,
            }}
          />
        </Stack>
      </Paper>

      <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' }, gap: 2 }}>
          <DetailField label="Cikk" value={itemLabel} />
          <DetailField label="Mennyiség" value={quantityValue} />
          <DetailField label="Dátum" value={docDate} />
          <DetailField label="Felhasználó" value={createdByLabel} />
          <DetailField label="Raktár" value={warehouseLabel} />
          <DetailField label="Tárhely" value={binLabel} />
        </Box>

        <Box sx={{ mt: 2 }}>
          <DetailField label="Megjegyzés" value={selectedValues?.note} />
        </Box>
      </Paper>

      <InventoryConversionTabs selectedValues={selectedValues} />
    </Box>
  );
};

export default InventoryConversionPage;
